export default __webpack_public_path__ + "static/media/IMG_9009 copie.27d51ef3.jpg";